$(document).ready(function(){
    
    $('.ugc_adh__video').each(function(){
        var video = $(this)[0];
        if (video) {
          video.pause();
        }
    });

    $('.ad_hero .adh_btn').click(function(){
        $('html, body').animate({
            scrollTop: $(".adh_b").offset().top
        }, 500);
    });

    $('.adh_slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        centerPadding: '30px'
    });
    $('.adh_ugc_grid_mob').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '30px'
              }
            }
        ]
    });

    // $('.adh_ugc_grid > div').mouseover(function(){
    //     console.log('mouseover');
    //     var video = $(this).find('video')[0];
    //     if (video) {
    //         video.play();
    //         video.volume = 1;
    //         video.muted = false;
    //         $(this).find('.adh_ugc_play').hide();
    //         // $(this).find('.adh_ugc_pause').show();
    //     }
    // });

    $('.adh_ugc_grid > div').click(function(){
        $('.adh_ugc_grid > div').addClass('notplaying');
        $(this).removeClass('notplaying');

        $('.adh_ugc_grid > div.notplaying').each(function(){
            var video = $(this).find('video')[0];
            video.pause();
            $(this).find('.adh_ugc_play').show();
            $(this).find('.adh_ugc_pause').hide();
        });

        var video = $(this).find('video')[0];
        if (video) {
            if (video.paused) {
                video.play();
                video.volume = 1;
                video.muted = false;
                $(this).find('.adh_ugc_play').hide();
                $(this).find('.adh_ugc_pause').show();
            }
            else{
                video.pause();
                $(this).find('.adh_ugc_play').show();
                $(this).find('.adh_ugc_pause').hide();
            }
            
        }
    });

   $('.adh_ugc_grid > div').mouseleave(function(){
     $(this).find('.adh_ugc_pause').hide();
   });

   $('.adh_ugc_grid > div').mouseover(function(){
     var video = $(this).find('video')[0];
     if (video) {
      if (video.paused) {
        
      }
      else{
        if ($(window).width() > 960) {
         $(this).find('.adh_ugc_pause').show();
        }
      }
     }
   });

    $('.adh_ugc_Cell').click(function(){
        console.log('clickedmob');
      
        $('.adh_ugc_Cell').addClass('notplaying');
        $(this).removeClass('notplaying');

        $('.adh_ugc_Cell.notplaying').each(function(){
            var video = $(this).find('video')[0];
            video.pause();
            $(this).find('.adh_ugc_play').show();
        });
      
        var video = $(this).find('video')[0];
        if (video) {
            if (video.paused) {
                video.play();
                video.volume = 1;
                video.muted = false;
                $(this).find('.adh_ugc_play').hide();
                $(this).find('.adh_ugc_pause').show();
            } else {
                video.pause();
                $(this).find('.adh_ugc_play').show();
                $(this).find('.adh_ugc_pause').hide();
            }
            
        }
    });

    // $('.adh_ugc_grid > div').mouseleave(function(){
    //     var video = $(this).find('video')[0];
    //     if (video) {
    //         video.pause();
    //         $(this).find('.adh_ugc_play').show();
    //         // $(this).find('.adh_ugc_pause').hide();
    //     }
    //     console.log('mouseleave');
    // });

    $('.adh_faq_cell').click(function(){
        $(this).toggleClass('active');
        $(this).find('.adh_faq_cell_cont').slideToggle();
    });

    var minutes = 14;
    var seconds = 59;
    
    // Calculate total seconds
    var totalSeconds = minutes * 60 + seconds;
    
    // Display initial time
    $('.adh_min').text(minutes);
    $('.adh_sec').text(seconds);
    
    // Update the timer every second
    var timer = setInterval(function(){
        // Decrease total seconds
        totalSeconds--;
        
        // Calculate remaining minutes and seconds
        var remainingMinutes = Math.floor(totalSeconds / 60);
        var remainingSeconds = totalSeconds % 60;
        
        // Update the HTML with the new time
        $('.adh_min').text(remainingMinutes < 10 ? '0' + remainingMinutes : remainingMinutes);
        $('.adh_sec').text(remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds);
        
        // If the countdown is over, stop the timer
        if(totalSeconds <= 0){
            clearInterval(timer);
            // You can add actions to be performed after countdown finishes here
        }
    }, 1000);

});

document.addEventListener("DOMContentLoaded", function() {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
  
            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  });